var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u-reset home-intro-scroller", class: [_vm.rootClasses] },
    [
      _c(
        "transition",
        { attrs: { name: "trs-simple-fade", mode: "out-in" } },
        [
          _vm.firstLocation && !_vm.showButton
            ? _c(
                "router-link",
                {
                  key: "scroller",
                  staticClass: "u-reset home-intro-scroller--wrap",
                  attrs: { to: _vm.firstLocation }
                },
                [
                  _c("span", {
                    staticClass: "home-intro-scroller--title",
                    domProps: {
                      textContent: _vm._s(_vm.translate("HOME.SCROLLER_TITLE"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "home-intro-scroller--visual" }, [
                    _c("img", {
                      staticClass: "home-intro-scroller--img",
                      attrs: {
                        src: _vm._f("static")("img/im_scroll.svg"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "home-intro-scroller--ani" })
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.firstLocation && _vm.showButton
            ? _c("router-link", {
                key: "btn",
                staticClass: "btn btn__primary home-intro-scroller--btn",
                attrs: { to: _vm.firstLocation },
                domProps: {
                  textContent: _vm._s(_vm.translate("HOME.SCROLLER_TITLE"))
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17983f91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17983f91","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/home-intro-scroller/index.vue
// module id = 353
// module chunks = 5